import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KeywordOptimizationResponse, KeywordOptimizationError } from '../Model/KeywordOptimization';

interface KeywordState {
  loading: boolean;
  result: KeywordOptimizationResponse | null;
  error: KeywordOptimizationError | null;
}

const initialState: KeywordState = {
  loading: false,
  result: null,
  error: null,
};

const keywordSlice = createSlice({
  name: 'keyword',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setResult: (state, action: PayloadAction<KeywordOptimizationResponse>) => {
      state.result = action.payload;
      state.error = null;
    },
    setError: (state, action: PayloadAction<KeywordOptimizationError>) => {
      state.error = action.payload;
      state.result = null;
    },
    clearKeywordState: (state) => {
      state.loading = false;
      state.result = null;
      state.error = null;
    },
  },
});

export const { setLoading, setResult, setError, clearKeywordState } = keywordSlice.actions;
export default keywordSlice.reducer;
